module.exports = __webpack_public_path__ + "static/media/Julia_Vaz_Praticas_yoga_blocos.847e9877.jpg";